import { render, staticRenderFns } from "./transport-pricing-card.vue?vue&type=template&id=2c463e68"
import script from "./transport-pricing-card.vue?vue&type=script&lang=js"
export * from "./transport-pricing-card.vue?vue&type=script&lang=js"
import style0 from "./transport-pricing-card.vue?vue&type=style&index=0&id=2c463e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports